import { useTranslate } from "ra-core";
import { Link, useLocation } from "react-router";
import { cn } from "@/lib/utils";

/** «Настройки» (owner only): general settings, projects, employees, connections, letter templates. */
export const SettingsTabs = ({ className }: { className?: string }) => {
  const translate = useTranslate();
  const { pathname } = useLocation();
  const tabs = [
    { to: "/settings", label: "crm.projects.general" },
    { to: "/settings/projects", label: "crm.projects.title" },
    { to: "/settings/staff", label: "crm.projects.staff_title" },
    { to: "/settings/connections", label: "crm.connections.title" },
    { to: "/settings/mail-templates", label: "crm.mail_templates.title" },
  ];

  return (
    <nav
      aria-label={translate("crm.projects.tabs_label")}
      className={cn(
        "flex flex-wrap gap-1 rounded-lg bg-muted p-1 w-fit max-w-full",
        className,
      )}
    >
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          aria-current={pathname === tab.to ? "page" : undefined}
          className={cn(
            "rounded-md px-4 py-1.5 text-sm font-medium transition-colors",
            pathname === tab.to
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {translate(tab.label)}
        </Link>
      ))}
    </nav>
  );
};
